import React from 'react';
import MainLayout from './layout/MainLayout';
import Home from './pages/Home';

function App() {
  return (
    <MainLayout>
      <Home />
    </MainLayout>
  );
}

export default App;
